//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import VueNumberInput from '@chenfengyuan/vue-number-input';
// import jQuery from 'jquery';
import axios from 'axios';

Vue.use(DatePickerPlugin);
Vue.use(VueNumberInput);
export default {
    methods:{
        onFocus: function(args){
            this.$refs.dateObj.show();
        },
        onClose: function(args){
            // console.log('here');
        },
        onChange: function(args){
            var v = this;
            var data = new FormData();

            if (args.event.target.title) {
                data.append('selected_date', args.event.target.title);
                data.append('marketing_item', window.marketid);
                data.append('title', window.title);
                data.append('action', 'setuserevent');
                this.notice = '<h4>Added to planner!</h4>';

                axios
                    .post(ajax_object.ajax_url, data)
                    .then(response => {
                        this.dateval = new Date();
                        setTimeout(function() {
                            v.notice = '';
                        }, 2000);
                    });
            }
            
        },
    },

    // dateval: '01/01/2019'
    data () {

        let mailingnum = window.mailingrecipients;
        if (mailingnum < window.qty) {
            mailingnum = window.qty;
        }

        return{
            notice: '',
            delivery: 'Shipped',
            dateval: new Date(window.setdate),
            productid: window.productid,
            productidmailed: window.productidmailed,
            marketid: window.marketid,
            value: 1,
            type: window.itemtype,
            printtype: window.printtype,
            outerlink: window.outerlink,
            linklabel: window.linklabel,
            customized: window.customized,
            directmail: window.directmail,
            directmaillist: window.directmaillist,
            mailingrecipients: mailingnum,
            addtoplanner: window.addtoplanner,
            missingteamname: window.missingteamname,
            missingteamlogo: window.missingteamlogo,
            teammember: window.teammember,
            downloadonly: window.downloadonly,
            hideplanner: window.hideplanner,
            qty: window.qty,
        }
    },
}



// WEBPACK FOOTER //
// ./scripts/Marketingitem.vue